<template>
  <div id="app">
    <template v-if="show">
    <app-header></app-header>
    <router-view />
    <app-footer></app-footer>
  
  </template>
  </div>
</template>

<script>

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'
  import CookieLaw from 'vue-cookie-law'

  import { mapActions } from 'vuex';

  export default {
    name: 'App',
    components: {
      'app-header': header,
      'app-footer': footer,
      'cookie-law': CookieLaw
    },
    mounted() {
      this.requestNoticias();

      if(location.search == '?9847hgfh74832'){
        this.show = true;
      }
    },
    methods: {
      ...mapActions(['requestNoticias'])
    },
    data(){
      return{
        show : true
      }
    }


  }
</script>

<style lang="scss">
  @import '@/assets/css/colors.scss';
  @import './assets/css/slick.css';
  @import './assets/css/style.scss';
  @import './assets/css/responsive.scss';
  @import url('https://fonts.googleapis.com/css?family=Martel+Sans:300,400,700&display=swap');
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
  @import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
</style>


// WEBPACK FOOTER //
// src/App.vue